import { AfterViewChecked, Component, OnInit } from '@angular/core';
import { JhiAlertService, JhiEventManager } from 'ng-jhipster';
import { Subscription } from 'rxjs/Subscription';
import * as $ from 'jquery';

import { Account, Faculty, Queue } from '../../../models';
import { FacultyService, Principal } from '../../../services';
import { AlertUtils } from '../../../shared';
import { QUEUE_LIST_MODIFICATION } from '../../../shared/constants';

@Component({
    selector: 'qms-queues-grid',
    templateUrl: './queues-grid.component.html'
})
export class QueuesGridComponent implements OnInit, AfterViewChecked {

    public queues: Queue[];

    private currentAccount: Account;

    private eventSubscription: Subscription;

    constructor(private facultyService: FacultyService,
                private alertService: JhiAlertService,
                private eventManager: JhiEventManager,
                private principal: Principal) {
    }

    private reloadUserAndLoadQueues() {
        this.principal.identity().then((account) => {
            this.currentAccount = account;
            this.reloadQueues();
        });
    }

    private reloadQueues() {
        this.principal.userFaculties().subscribe((faculties: Faculty[]) => {
            this.queues = [];
            faculties.forEach((faculty: Faculty) => {
                this.facultyService.findFinalQueues(faculty.id).subscribe((queues: Queue[]) => {
                    this.queues = this.queues.concat(queues);
                });
            });
        });
    }

    ngOnInit() {
        this.reloadUserAndLoadQueues();
        this.registerChangeInQueues();
    }

    ngAfterViewChecked() {
        this.resizeNames();
    }

    private onError(error) {
        AlertUtils.notifyError(this.eventManager, this.alertService, error.message, null);
    }

    private resizeNames() {
        let maxHeight = 0;
        const box = $('div.name-box');
        box.each(function() {
            maxHeight = ($(this).height() > maxHeight ? $(this).height() : maxHeight);
        });
        box.height(maxHeight);
    }

    private registerChangeInQueues() {
        this.eventSubscription = this.eventManager
            .subscribe(QUEUE_LIST_MODIFICATION, (response) => this.reloadQueues());
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/components/home/queues-grid/queues-grid.component.ts